// extracted by mini-css-extract-plugin
module.exports = {"root":"Title_root__zLxC2"};